export default {
  country: 'Pays',
  language: 'Langue',
  currency: 'Devise',
}
